import { NO_SKILL_TILE, NO_SKILL_TILE_PICKER, paletteFor } from '../../../shared/catalog.js'

// [box, radius, font] per design §5.1
const SIZES = {
  xs: [14, 4, 9],
  sm: [15, 4, 9],
  step: [16, 4, 9],
  md: [16, 4, 10],
  card: [30, 8, 13],
  picker: [32, 8, 13],
  choice: [36, 9, 15],
  list: [40, 10, 16],
  header: [52, 13, 21],
}

export function tileColors(system, { picker = false } = {}) {
  if (!system || system.status === 'none') {
    const disabled = picker ? NO_SKILL_TILE_PICKER : NO_SKILL_TILE
    return { background: disabled.tile, color: disabled.letter }
  }
  return { background: paletteFor(system.palette).tile, color: '#FFFFFF' }
}

export function SystemTile({ system, size = 'md', picker = false, ring, style }) {
  const [box, radius, font] = SIZES[size] ?? SIZES.md
  const colors = tileColors(system, { picker })
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: box,
        height: box,
        borderRadius: radius,
        fontSize: font,
        fontWeight: 600,
        lineHeight: 1,
        ...colors,
        ...(ring ? { boxShadow: `0 0 0 1.5px ${ring}` } : {}),
        ...style,
      }}
    >
      {system?.letter ?? '?'}
    </span>
  )
}

/** Two overlapping tiles for two-system history items. */
export function TilePair({ systems, size = 'xs', ringColor = '#EEEBE4' }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      {systems.map((system, i) => (
        <SystemTile
          key={system?.slug ?? i}
          system={system}
          size={size}
          ring={i > 0 ? ringColor : undefined}
          style={i > 0 ? { marginLeft: -3 } : undefined}
        />
      ))}
    </span>
  )
}
